/* ZSportsTech — section-nshero.js
   Scoped to #sc-nshero (Net Sessions hero). Vanilla JS only.
   Maps to → assets/section-nshero.js in Shopify theme.
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  var hero = document.getElementById('sc-nshero');
  if (!hero) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ── 1. Bg <video> — play only while in view ────────
     Activates when settings.hero_video drops a <video>
     into .sc-nshero (replacing the CSS stage).            */
  var vid = hero.querySelector('video.sc-nshero__bg');
  if (vid) {
    vid.setAttribute('playsinline', '');
    vid.muted = true;
    if ('IntersectionObserver' in window && !reduce.matches) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { vid.play().catch(function () {}); }
          else { vid.pause(); }
        });
      }, { threshold: 0.15 }).observe(hero);
    } else {
      vid.pause();
    }
  }

  /* ── 2. CTA → smooth-scroll to the booking section ──
     Falls back to native anchor jump if target absent.   */
  var cta = hero.querySelector('[data-scroll]');
  if (cta) {
    cta.addEventListener('click', function (ev) {
      var id = (cta.getAttribute('href') || '').replace(/^#/, '');
      var target = id && document.getElementById(id);
      if (!target) return; /* let the browser navigate the route */
      ev.preventDefault();
      target.scrollIntoView({
        behavior: reduce.matches ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  }

}());
